export const navigationItems = [
  { label: "Home", path: "/" },
  { label: "Solar", path: "/solar-services" },
  { label: "Roofing", path: "/roofing-services" },
  { label: "About", path: "/about" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact", path: "/contact" },
];